// 组件渲染器，用于根据组件配置动态渲染组件
class ComponentRenderer {
  constructor() {
    this.renderers = new Map();
    this.styleElement = null;
  }

  // 注册组件渲染器
  registerRenderer(componentName, renderer) {
    this.renderers.set(componentName, renderer);
  }

  // 获取组件渲染器
  getRenderer(componentName) {
    return this.renderers.get(componentName);
  }

  // 渲染组件HTML
  renderComponent(component) {
    const renderer = this.getRenderer(component.componentName);
    if (renderer && renderer.renderHtml) {
      return renderer.renderHtml(component.props, component.canvasWidth, component);
    }
    // 默认渲染
    return `<div class="component-${component.componentName}">${component.componentName}</div>`;
  }

  // 渲染组件样式
  renderComponentStyle(componentName) {
    const renderer = this.getRenderer(componentName);
    if (renderer && renderer.renderStyle) {
      return renderer.renderStyle();
    }
    return '';
  }

  // 渲染所有组件样式
  renderAllStyles() {
    let styles = '';
    for (const [name, renderer] of this.renderers) {
      if (renderer.renderStyle) {
        styles += renderer.renderStyle();
      }
    }
    return styles;
  }

  // 将所有组件样式注入到页面中
  injectAllStyles() {
    if (!this.styleElement) {
      this.styleElement = document.createElement('style');
      this.styleElement.id = 'component-styles';
      document.head.appendChild(this.styleElement);
    }
    this.styleElement.textContent = this.renderAllStyles();
  }
}

// 导出单例实例
export default new ComponentRenderer();